// Vendor
import {combineReducers} from 'redux';

// Reducers
import {
  reducer as session,
  State as SessionState
} from 'isee/redux/session/reducer';

// Types
interface StoreEnhancerState {}

export interface RootState extends StoreEnhancerState {
  session: SessionState;
}

export const rootReducer = combineReducers<RootState>({
  session
});



// WEBPACK FOOTER //
// ./src/redux/root-reducer.ts